import { ThemeProvider } from '@mui/material'
import { styled } from '@mui/system'
import { MainTemplate } from 'Components/Template/MainTemplate'
import { observer } from 'mobx-react-lite'
import SignUpElem from './../Elements/SignUp/SignUp'
import ReferralBar from 'Components/Elements/Referral/ReferralBar'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { Navigate } from 'react-router-dom'
import { get } from 'lodash'
import { toJS } from 'mobx'

const SignUp = observer(() => {
    const pageConfig = toJS(StoreCheckout.CheckOutInstance().GetPageConfig())
    if (get(pageConfig, 'signUp.disable')) {
        return <Navigate to="/" replace />
    }

    return (
            <ThemeProvider theme={MainTemplate}>
                {!StoreAuth.isAuthorized && <ReferralBar />}
                <SignUpWrapper>
                    <SignUpElem />
                </SignUpWrapper>
            </ThemeProvider>
    )
})

const SignUpWrapper = styled('div')`
    background-color: #d1d9e2;
    height: auto;
    display: flex;
    justify-content: center;
    padding: 20px;

    @media screen and (min-width: 700px) {
        padding: 40px 70px 100px 70px;
    }
`

export default SignUp
